import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { BRANCH_REQUEST_ID_LIST } from './branch-constant';
import { envConfig } from '../../../../config';

class BranchServiceClass {
  getBranch = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/company-admin/shops',
      id: BRANCH_REQUEST_ID_LIST.GET_BRANCH
    });
  }

  deleteBranch = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: envConfig.hostname + 'v1/merchant/company-admin/shops',
      config: { headers: { shopId: params.data } },
      id: BRANCH_REQUEST_ID_LIST.DELETE_BRANCH
    });
  }

  editBranch = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/shops',
      data: params.data,
      id: BRANCH_REQUEST_ID_LIST.EDIT_BRANCH
    });
  }

  addBranch = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/shops',
      data: params.data,
      id: BRANCH_REQUEST_ID_LIST.ADD_BRANCH
    });
  }

  addMartBranch = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/shops-mart',
      data: params.data,
      id: BRANCH_REQUEST_ID_LIST.ADD_MART_BRANCH
    });
  }

  mappingBranchVat = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/vat-addresses/mapping',
      data: params.data,
      id: BRANCH_REQUEST_ID_LIST.MAPPING_BRANCH_VAT
    });
  }

  deleteMartBranch = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: envConfig.hostname + 'v1/merchant/company-admin/shops-mart',
      config: { headers: { shopId: params.data } },
      id: BRANCH_REQUEST_ID_LIST.DELETE_MART_BRANCH
    });
  }
}

export const BranchService = new BranchServiceClass();
